<template>
  <div>企预测</div>
</template>

<script>
export default {};
</script>

<style>
</style>